import client from './client';
import { DashboardResp, MapDashboardResp, MapEquipListResp, PlantImageResp } from './response';

export const getDashboard = (factoryId: string): Promise<DashboardResp> =>
  client.get('v1/dashboard', { params: { factoryId } });

export const getMapDashboard = (factoryId: string): Promise<MapDashboardResp> => client.get('v1/dashboard/map', { params: { factoryId } });
export const getMapEquipList = (sectionId: number): Promise<MapEquipListResp> => client.get(`v1/dashboard/map/${sectionId}`);

export const getPlantImage = (factoryId?: string): Promise<PlantImageResp> => client.get('file/factory/image', { params: { factoryId } });
